import { useMutation, useQuery } from "@tanstack/react-query";
import api from "../../api/axios";

export default function useInvoiceHook() {
  const submitInvoiceMutation = useMutation({
    mutationFn: async (invoiceData) => {
      const res = await api.post(
        "/accounts/users/create/invoice/",
        invoiceData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return res.data;
    },
    onSuccess: (queryClient) => {
      // Optionally invalidate or refetch invoice list here
      window.location.href = "/invoices/"; // Redirect to invoice list after successful submission
      queryClient.invalidateQueries(["invoiceList"]);
    },
  });

  const updateInvoiceMutation = useMutation({
    mutationFn: async ({ uuid, invoiceData }) => {
      const res = await api.put(`/invoices/edit/${uuid}/`, invoiceData, {
        headers: { "Content-Type": "application/json" },
      });
      return res.data;
    },
    onSuccess: (data, variables, context) => {
      // window.location.reload();
      context.queryClient.invalidateQueries(["invoiceList", "invoice_fetch"]);
    },
  });
  const FetchSingleInvoice = (uuid) => {
    const { data: invoice, isLoading: invoiceLoading } = useQuery({
      queryKey: ["invoice_fetch", uuid],
      queryFn: async () => {
        const res = await api.get(`/invoice/${uuid}/`);
        return res.data;
      },
      enabled: !!uuid, // only run if uuid is provided
      retry: false,
    });
    return { invoice, invoiceLoading };
  };
  const FetchCustomerInvoiceDetails = (uuid) => {
    const { data: invoice, isLoading: invoiceLoading } = useQuery({
      queryKey: ["customer_invoice_fetch", uuid],
      queryFn: async () => {
        const res = await api.get(`invoice/customer/${uuid}/details`);
        return res.data;
      },
      enabled: !!uuid, // only run if uuid is provided
      retry: false,
    });
    return { invoice, invoiceLoading };
  };
  const sendInvoiceEmailMutation = useMutation({
    mutationFn: async ({ invoiceId, attachedDocuments }) => {
      const res = await api.post(
        `/invoice/${invoiceId}/send-email/`,
        attachedDocuments,
        {
          headers: {
            "Content-Type": "application/json",
            credentials: "include",
            "X-CSRFToken": document.cookie
              .split("; ")
              .find((row) => row.startsWith("csrftoken="))
              ?.split("=")[1],
          },
        }
      );
      return res.data;
    },
  });

  const FetchInvoiceStatus = () => {
    const { data: status } = useQuery({
      queryKey: ["customer_invoice_status"],
      queryFn: async () => {
        const res = await api.get(`dashboard/status/`);
        return res.data;
      },

      retry: false,
    });
    return { status };
  };
  const submitInvoiceLoading = submitInvoiceMutation.isLoading;

  return {
    submitInvoiceMutation,
    submitInvoiceLoading,
    FetchSingleInvoice,
    updateInvoiceMutation,
    FetchCustomerInvoiceDetails,
    sendInvoiceEmailMutation,
    FetchInvoiceStatus,
  };
}
